import React, { useEffect, useState, useContext } from "react";
import SideBar from "../../../components/common/SideBar/SideBarNew";
import { LoginContext } from "../../../helpers/LoginContext";
import {
  emptyPaginationObj,
  POLICIES_LIST_LIMIT,
  StatusOptions,
} from "../../../Constants/constant";
import { resolveListingSort } from "../../../Constants/listingSort";
import { getPaginationObj } from "../../../Utils/utils";
import {
  LOADER_STATUS,
  PERMISSION_KEYS,
  PERMISSION_KEYS_CHILDREN,
} from "../../../store/constants";
import AddParticipantModal from "./AddParticipantModal";
import ParticipantListTable from "./ParticipantListTable";
import { roleAccess } from "helpers/RolesPermission";
import useParticipantListingsPerPage from "hooks/useParticipantListingsPerPage";

const ParticipantList = (props) => {
  const {
    getParticipantList,
    spParticipants,
    loading,
    getSupportCoordinators,
    supportCoordinator,
    supportCoordinatorLoader,
    settings,
    getSpSettingRequest,
    loginUser,
    resetParticipantListInParticipant
  } = props;

  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const { pageSize, pageSizeRef, remoteSyncToken, changePageSize } =
    useParticipantListingsPerPage();

  const [coSelectedStatus, setCosSelectedStatus] = useState(null);
  const [renderLoading, setRenderLoading] = useState(LOADER_STATUS.NA);
  const [openModal, setOpenModal] = useState(false);
  const [paginationObj, setPaginationObj] = useState(
    spParticipants
      ? getPaginationObj(
          spParticipants.participant,
          spParticipants.query_params
        )
      : emptyPaginationObj
  );

  useEffect(() => {
    getSpSettingRequest();
  }, []);

  //console.log(settings?.participant_type);

  useEffect(() => {
    if (!loading && renderLoading === LOADER_STATUS.PENDING) {
      setRenderLoading(LOADER_STATUS.COMPLETE);
    }
  }, [loading]);

  // useEffect(() => getSupportCoordinators({ page: 1 }), []);

  useEffect(() => {
    if (spParticipants) {
      setPaginationObj(
        getPaginationObj(
          spParticipants.participant,
          spParticipants.query_params
        )
      );
    }
  }, [spParticipants]);

  useEffect(() => {
    if (spParticipants) {
      setPaginationObj(
        getPaginationObj(
          spParticipants.participant,
          spParticipants.query_params
        )
      );
    }
  }, []);

  const fetchFormTemplateList = async (filters) => {
    if (!filters || filters === undefined) {
      Object.assign((filters = {}), {
        page: paginationObj.page,
      });
    }
    Object.assign(filters, {
      per_page: pageSizeRef.current || POLICIES_LIST_LIMIT,
    });

    if (filters.sc_id !== 1) {
      Object.assign(filters, {
        sc_id: filters.sc_id === 1 ? undefined : filters.sc_id,
      });
      Object.assign(filters, {
        sc_id:
          filters.sc_id === undefined
            ? coSelectedStatus?.id === 1
              ? undefined
              : coSelectedStatus?.id
            : filters.sc_id === 1
            ? undefined
            : filters.sc_id,
      });
    } else {
      Object.assign(filters, {
        sc_id: undefined,
      });
    }
    let bodyFilter = filters.hasOwnProperty("filter") ? filters.filter : null;
    if (filters.hasOwnProperty("filter")) {
      delete filters.filter;
    }
    if (filters.status === "both") {
      bodyFilter = null;
    }
    if (renderLoading === LOADER_STATUS.NA) {
      setRenderLoading(LOADER_STATUS.PENDING);
    }
    getParticipantList({ filters, bodyFilter });
  };

  const handleFetch = (obj, sortBy) => {
    const updatedObj = { ...obj };

    // Set default status to 'active' only if no search or status
    if (
      !updatedObj.hasOwnProperty("status") &&
      !updatedObj.hasOwnProperty("search")
    ) {
      updatedObj.status = "active";
    }

    if (!updatedObj.hasOwnProperty("participant_type")) {
      updatedObj.participant_type = "both";
    }

    // Initialize filter object
    let filter = {};

    // Handle status condition
    if (updatedObj.hasOwnProperty("status") && updatedObj.status !== "both") {
      filter.status = [updatedObj.status];
    }

    // Always include participant_type in filter
    if (updatedObj.hasOwnProperty("participant_type")) {
      filter.participant_type = updatedObj.participant_type;
    }

    // Assign filter to payload
    updatedObj.filter = filter;

    // Remove top-level status and participant_type
    delete updatedObj.status;
    delete updatedObj.participant_type;

    Object.assign(updatedObj, resolveListingSort(updatedObj, sortBy, paginationObj));

    // Page number
    updatedObj.page = updatedObj.hasOwnProperty("page")
      ? updatedObj.page
      : paginationObj.page;

    // Handle search
    if (updatedObj.hasOwnProperty("search")) {
      updatedObj.page = 1;
      updatedObj.sc_id = updatedObj.sc_id === 1 ? undefined : updatedObj.sc_id;
    } else if (paginationObj.search) {
      updatedObj.search = paginationObj.search;
    }

    // Handle SC ID for default fetch
    if (updatedObj.sc_id === 1) {
      updatedObj.sc_id = undefined;
    }

    // Show loader only if it's the initial load
    if (renderLoading === LOADER_STATUS.NA) {
      setRenderLoading(LOADER_STATUS.PENDING);
    }

    fetchFormTemplateList(updatedObj);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [paginationObj.page]);

  const hasCorePermission = roleAccess(
    [],
    PERMISSION_KEYS.PARTICIPANT,
    PERMISSION_KEYS_CHILDREN.PARTICIPANT.CORE
  );
  const hasCosPermission = roleAccess(
    [],
    PERMISSION_KEYS.PARTICIPANT,
    PERMISSION_KEYS_CHILDREN.PARTICIPANT.COS
  );

  let defaultParticipantType = null;

  if (hasCorePermission && hasCosPermission) {
    defaultParticipantType =
      loginUser?.userType === "sp_manager"
        ? "core"
        : settings?.participant_type;
  } else if (hasCorePermission) {
    defaultParticipantType = "core";
  } else if (hasCosPermission) {
    defaultParticipantType = "cos";
  }
//  useEffect(() => {
//   if (!hasCorePermission && !hasCosPermission) return; // ✅ No permission, stop fetch
//   if (defaultParticipantType) {
//     handleFetch({
//       participant_type: defaultParticipantType,
//       sc_id: coSelectedStatus?.id,
//       page: 1,
//     });
//   }
// }, [defaultParticipantType, coSelectedStatus]);

useEffect(() => {
   resetParticipantListInParticipant();
  return () => {
    resetParticipantListInParticipant();
  }
},[])
  return (
    <>
      <div className='min-h-full'>
        <SideBar />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300"
              : "lg:pl-64 duration-300"
          }  flex flex-col`}
        >
          <main className='h-screen flex-1 bg-white'>
            <ParticipantListTable
              setPaginationObj={setPaginationObj}
              paginationObj={paginationObj}
              templateList={
                spParticipants &&
                spParticipants?.participant &&
                spParticipants?.participant?.data &&
                spParticipants?.participant?.data?.length > 0
                  ? spParticipants?.participant?.data
                  : []
              }
              isLoading={loading}
              queryParams={paginationObj}
              formCategoriesList={StatusOptions}
              handleFetch={handleFetch}
              renderLoading={renderLoading}
              setRenderLoading={setRenderLoading}
              supportCoordinator={supportCoordinator}
              supportCoordinatorLoader={supportCoordinatorLoader}
              setCosSelectedStatus={setCosSelectedStatus}
              coSelectedStatus={coSelectedStatus}
              setOpenModal={setOpenModal}
              defaultParticipantType={defaultParticipantType}
  hasCorePermission={hasCorePermission}
  hasCosPermission={hasCosPermission}
  settings={settings}
              pageSize={pageSize}
              remoteSyncToken={remoteSyncToken}
              onPageSizeChange={changePageSize}


            />
          </main>
        </div>
      </div>
      {openModal && (
        <AddParticipantModal
          openModal={openModal}
          handleClose={() => setOpenModal(false)}
          isUserGracePeriodOver={isUserGracePeriodOver}
        />
      )}
    </>
  );
};

export default ParticipantList;
